import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Defaults_instancekan2vrugibmn as Defaults_instance } from './AiDriver.mjs';
import { KiteUiCoroutineScopeHelpers25rj47zs39igb as KiteUiCoroutineScopeHelpers } from './KiteUiCoroutineScopeHelpers.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_padding2xbtedaunn69u as get_padding } from './Element.ext.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../models/data.mjs';
import { minOf33o15vox9quzb as minOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DriverSnapshotOptionsClass;
function DriverSnapshotOptions() {
  if (DriverSnapshotOptionsClass === VOID) {
    class $ {
      constructor(includeHidden, interactiveOnly, includeThemes, includeActions) {
        includeHidden = includeHidden === VOID ? false : includeHidden;
        interactiveOnly = interactiveOnly === VOID ? false : interactiveOnly;
        includeThemes = includeThemes === VOID ? false : includeThemes;
        includeActions = includeActions === VOID ? true : includeActions;
        this.includeHidden_1 = includeHidden;
        this.interactiveOnly_1 = interactiveOnly;
        this.includeThemes_1 = includeThemes;
        this.includeActions_1 = includeActions;
      }
      toString() {
        return 'DriverSnapshotOptions(includeHidden=' + this.includeHidden_1 + ', interactiveOnly=' + this.interactiveOnly_1 + ', includeThemes=' + this.includeThemes_1 + ', includeActions=' + this.includeActions_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.includeHidden_1);
        result = imul(result, 31) + getBooleanHashCode(this.interactiveOnly_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.includeThemes_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.includeActions_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DriverSnapshotOptions()))
          return false;
        if (!(this.includeHidden_1 === other.includeHidden_1))
          return false;
        if (!(this.interactiveOnly_1 === other.interactiveOnly_1))
          return false;
        if (!(this.includeThemes_1 === other.includeThemes_1))
          return false;
        if (!(this.includeActions_1 === other.includeActions_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DriverSnapshotOptions', DriverSnapshotOptions);
    DriverSnapshotOptionsClass = $;
  }
  return DriverSnapshotOptionsClass;
}
var DebuggerClass;
function Debugger() {
  if (DebuggerClass === VOID) {
    class $ {
      constructor() {
        Debugger_instance = this;
        this.removeBeforeShutdown_1 = false;
        this.leakDetect_1 = false;
        this.debugTarget_1 = null;
        this.countInstances_1 = false;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.liveInstancesByClass_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        this.liveInstanceTotal_1 = 0;
      }
      recordCreated_ej7mju_k$(element) {
        this.liveInstanceTotal_1 = this.liveInstanceTotal_1 + 1 | 0;
        var tmp0_elvis_lhs = getKClassFromExpression(element).get_simpleName_r6f8py_k$();
        var k = tmp0_elvis_lhs == null ? '?' : tmp0_elvis_lhs;
        var tmp0 = this.liveInstancesByClass_1;
        var tmp1_elvis_lhs = this.liveInstancesByClass_1.get_wei43m_k$(k);
        // Inline function 'kotlin.collections.set' call
        var value = (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + 1 | 0;
        tmp0.put_4fpzoq_k$(k, value);
      }
      recordShutdown_cnq552_k$(element) {
        this.liveInstanceTotal_1 = this.liveInstanceTotal_1 - 1 | 0;
        var tmp0_elvis_lhs = getKClassFromExpression(element).get_simpleName_r6f8py_k$();
        var k = tmp0_elvis_lhs == null ? '?' : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = this.liveInstancesByClass_1.get_wei43m_k$(k);
        var v = (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) - 1 | 0;
        if (v <= 0)
          this.liveInstancesByClass_1.remove_gppy8k_k$(k);
        else {
          // Inline function 'kotlin.collections.set' call
          this.liveInstancesByClass_1.put_4fpzoq_k$(k, v);
        }
      }
    }
    initMetadataForObject($, 'Debugger');
    DebuggerClass = $;
  }
  return DebuggerClass;
}
var Debugger_instance;
function Debugger_getInstance() {
  if (Debugger_instance === VOID)
    new (Debugger())();
  return Debugger_instance;
}
function get_driverValue() {
  return null;
}
function get_driverActions() {
  return Defaults_instance.defaultDriverActions_pnx2nx_k$(this);
}
function driverDisplay(options) {
  return Defaults_instance.defaultDriverDisplay_vqjzqt_k$(this, options);
}
var ElementClass;
function Element() {
  if (ElementClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Element', VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    ElementClass = $;
  }
  return ElementClass;
}
function addChild(element) {
  return this.addChild_51cm2s_k$(this.get_children_4cwbp4_k$().get_size_woubt6_k$(), element);
}
function removeChild(element) {
  var i = this.get_children_4cwbp4_k$().indexOf_si1fv9_k$(element);
  if (!(i === -1)) {
    this.removeChild_mjbjbk_k$(i);
  } else
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(element.toString() + ' is not a child of ' + this.toString() + '!');
}
function clearChildren() {
  var inductionVariable = this.get_children_4cwbp4_k$().get_size_woubt6_k$() - 1 | 0;
  if (0 <= inductionVariable)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      this.removeChild_mjbjbk_k$(i);
    }
     while (0 <= inductionVariable);
}
function get_spacingForChildCornerRadii() {
  var tmp0_elvis_lhs = get_padding(this);
  var tmp;
  var tmp_0 = tmp0_elvis_lhs;
  if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
    tmp = this.get_themeAndBack_k3yag2_k$().theme_1.padding_1.top_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var pad = tmp;
  var gap = this.get_themeAndBack_k3yag2_k$().theme_1.gap_1;
  return minOf(new (Dimension())(pad), new (Dimension())(gap)).value_1;
}
var ContainerElementClass;
function ContainerElement() {
  if (ContainerElementClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ContainerElement', VOID, VOID, [Element(), ElementWithChildren(), KiteUiCoroutineScopeHelpers()]);
    ContainerElementClass = $;
  }
  return ContainerElementClass;
}
var ElementWithChildrenClass;
function ElementWithChildren() {
  if (ElementWithChildrenClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ElementWithChildren', VOID, VOID, [Element()]);
    ElementWithChildrenClass = $;
  }
  return ElementWithChildrenClass;
}
function Element$Debugger$_get_debugTarget_$ref_hg3jj3(p0) {
  return constructCallableReference(() => p0.debugTarget_1, 0, 0, 104, VOID, [p0]);
}
function Element$Debugger$_set_debugTarget_$ref_rjtr1n(p0) {
  return constructCallableReference((p0_0) => {
    p0.debugTarget_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 105, VOID, [p0]);
}
function Element$_get_themeChoice_$ref_lsylda(p0) {
  return constructCallableReference(() => p0.get_themeChoice_22tyn3_k$(), 0, 0, 106, VOID, [p0]);
}
function Element$_set_themeChoice_$ref_bp8duq(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_themeChoice_py59um_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 107, VOID, [p0]);
}
//region block: exports
export {
  get_spacingForChildCornerRadii as get_spacingForChildCornerRadiitm4iw4dfs7u2,
  ContainerElement as ContainerElementjaaooy2agvhc,
  DriverSnapshotOptions as DriverSnapshotOptions27dyx43p9jzht,
  get_driverActions as get_driverActionsql9tpg6sskd4,
  driverDisplay as driverDisplay2w9hnlh9xpqdc,
  get_driverValue as get_driverValue2l8j2029z0kp4,
  ElementWithChildren as ElementWithChildren23tv2h1ul7ktb,
  Element as Element1y2xoj9fs2s4,
  Debugger_getInstance as Debugger_getInstancengm4b9abzu1y,
  Element$_get_themeChoice_$ref_lsylda as Element$_get_themeChoice_$ref_lsylda2osm2sk65qcho,
  Element$_set_themeChoice_$ref_bp8duq as Element$_set_themeChoice_$ref_bp8duq32iz468f7cncf,
  Element$Debugger$_get_debugTarget_$ref_hg3jj3 as Element$Debugger$_get_debugTarget_$ref_hg3jj310d00xurzosl8,
  Element$Debugger$_set_debugTarget_$ref_rjtr1n as Element$Debugger$_set_debugTarget_$ref_rjtr1nub17bo9f1toi,
};
//endregion

//# sourceMappingURL=Element.mjs.map
